import DoneAllIcon from '@mui/icons-material/DoneAll';
import { Alert, AlertProps, styled } from '@mui/material';
import {
  chromeYellow, kiwiGreen,
  sanguine, ultraMarine,
} from '../utils/colors';

const CogNeedAlert = styled(
  (props: AlertProps) => {
    if (props.icon) {
      return <Alert {...props} />;
    }
    if (props.severity === 'success') {
      return <Alert {...props} icon={<DoneAllIcon />} />;
    }
    return <Alert {...props} />;
  },
)({
  '&.MuiAlert-standardError': {
    backgroundColor: sanguine[100],
    color: sanguine[700],
    '& .MuiSvgIcon-root': {
      color: sanguine[600],
    },
  },

  '&.MuiAlert-standardSuccess': {
    backgroundColor: kiwiGreen[100],
    color: kiwiGreen[700],
    '& svg': {
      color: kiwiGreen[600],
    },
  },

  '&.MuiAlert-standardInfo': {
    backgroundColor: ultraMarine[100],
    color: ultraMarine[700],
    '& svg': {
      color: ultraMarine[600],
    },
  },

  '&.MuiAlert-standardWarning': {
    backgroundColor: chromeYellow[100],
    color: chromeYellow[700],
    '& svg': {
      color: chromeYellow[600],
    },
  },
});

export default CogNeedAlert;
